// @ts-nocheck
/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

export class ApiOwnerBalance {
    'consolidation_key': string;
    'created_at': Date;
    'updated_at': Date;
    'total_balance': number;
    'gradients_balance': number;
    'nextgen_balance': number;
    'memelab_balance': number;
    'unique_memelab': number;
    'memes_balance': number;
    'unique_memes': number;
    'genesis': number;
    'nakamoto': number;
    'memes_cards_sets': number;
    'memes_cards_sets_minus1': number;
    'memes_cards_sets_minus2': number;
    'boost': number;
    'boosted_tdh': number;
    'boosted_memes_tdh': number;
    'boosted_gradients_tdh': number;
    'boosted_nextgen_tdh': number;
    'total_balance_rank': number;
    'memes_balance_rank': number;
    'unique_memes_rank': number;
    'gradients_balance_rank': number;
    'nextgen_balance_rank': number;
    'memelab_balance_rank': number;
    'unique_memelab_rank': number;
    'boosted_tdh_rank': number;
    'boosted_memes_tdh_rank': number;
    'boosted_gradients_tdh_rank': number;
    'boosted_nextgen_tdh_rank': number;
    'xtdh': number;
    'xtdh_rank': number;

    static readonly discriminator: string | undefined = undefined;

    static readonly mapping: {[index: string]: string} | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "consolidation_key",
            "baseName": "consolidation_key",
            "type": "string",
            "format": ""
        },
        {
            "name": "created_at",
            "baseName": "created_at",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "updated_at",
            "baseName": "updated_at",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "total_balance",
            "baseName": "total_balance",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "gradients_balance",
            "baseName": "gradients_balance",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "nextgen_balance",
            "baseName": "nextgen_balance",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "memelab_balance",
            "baseName": "memelab_balance",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "unique_memelab",
            "baseName": "unique_memelab",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "memes_balance",
            "baseName": "memes_balance",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "unique_memes",
            "baseName": "unique_memes",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "genesis",
            "baseName": "genesis",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "nakamoto",
            "baseName": "nakamoto",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "memes_cards_sets",
            "baseName": "memes_cards_sets",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "memes_cards_sets_minus1",
            "baseName": "memes_cards_sets_minus1",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "memes_cards_sets_minus2",
            "baseName": "memes_cards_sets_minus2",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "boost",
            "baseName": "boost",
            "type": "number",
            "format": "double"
        },
        {
            "name": "boosted_tdh",
            "baseName": "boosted_tdh",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "boosted_memes_tdh",
            "baseName": "boosted_memes_tdh",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "boosted_gradients_tdh",
            "baseName": "boosted_gradients_tdh",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "boosted_nextgen_tdh",
            "baseName": "boosted_nextgen_tdh",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "total_balance_rank",
            "baseName": "total_balance_rank",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "memes_balance_rank",
            "baseName": "memes_balance_rank",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "unique_memes_rank",
            "baseName": "unique_memes_rank",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "gradients_balance_rank",
            "baseName": "gradients_balance_rank",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "nextgen_balance_rank",
            "baseName": "nextgen_balance_rank",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "memelab_balance_rank",
            "baseName": "memelab_balance_rank",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "unique_memelab_rank",
            "baseName": "unique_memelab_rank",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "boosted_tdh_rank",
            "baseName": "boosted_tdh_rank",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "boosted_memes_tdh_rank",
            "baseName": "boosted_memes_tdh_rank",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "boosted_gradients_tdh_rank",
            "baseName": "boosted_gradients_tdh_rank",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "boosted_nextgen_tdh_rank",
            "baseName": "boosted_nextgen_tdh_rank",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "xtdh",
            "baseName": "xtdh",
            "type": "number",
            "format": "double"
        },
        {
            "name": "xtdh_rank",
            "baseName": "xtdh_rank",
            "type": "number",
            "format": "int64"
        }    ];

    static getAttributeTypeMap() {
        return ApiOwnerBalance.attributeTypeMap;
    }

    public constructor() {
    }
}
